module.exports = __webpack_public_path__ + "static/media/Goal_complete.74040e4d.png";